import { jsx as o } from "react/jsx-runtime";

import { memo as e } from "react";

import s from "../hooks/useFieldSubscription.js";

import r from "../hooks/useGlobals.js";

const t = o => o.opened, i = e((e => {
    const {model: i, components: l} = r();
    return s(i, t) ? o(l.Dialog, {
        onClose: () => i.toggle(!1),
        children: o(l.ViewChooser, {
            ...e,
            className: "p-s bg-white"
        })
    }) : null;
}));

export { i as default };
//# sourceMappingURL=ViewChooserDialog.js.map
